const api = "https://agm.ingeniosvirtuales.com/api/";
// const api = "http://127.0.0.1:8000/api/";
// const api = "http://192.168.1.96/api/";
export default api;